<template>
  <div>
    <b-breadcrumb :items="navigationItems" />
    <b-container>
      <b-row>
        <b-col cols="12">
          <h2>Settings</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-tabs content-class="mt-3">
            <b-tab title="IP Blacklist">
              <ip-blacklist id="ip-blacklist" />
            </b-tab>
            <b-tab title="Properties">
              <properties id="configurable-properties" />
            </b-tab>
            <b-tab title="Tools">
              <b-button
                variant="warning"
                class="ml-3"
                @click="publishAllConfigurations"
              >
                <i class="fa fa-share-square" /> Publish All Configurations
              </b-button>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Properties from '../UIComponents/Properties'
import IpBlacklist from '../UIComponents/IPBlacklist'
import { dataAPI } from '../services/DataAPI'

export default {
  components: {
    Properties,
    IpBlacklist
  },
  data() {
    return {
      navigationItems: [{
        text: 'Home',
        to: { name: 'home' }
      }, {
        text: 'Payments',
        to: { name: 'client' }
      }, {
        text: 'Settings',
        active: true
      }]
    }
  },
  methods: {
    publishAllConfigurations() {
      return dataAPI(this.currentUserToken).publishAllConfigurations()
    }
  }
}
</script>
